<div class="diagram-container">
  @for (bar of _evaluationData; let i = $index; track bar) {
    <button
      [class.selected]="
        i === 0 && selectedState() === process.errorId ||
        i === 1 && selectedState() === process.warningId ||
        i === 2 && selectedState() === process.okId
    "
      [class]="'bar-container'"
      (click)="barClicked.emit({state: getStateByIndex(i), event: $event});">
      <div
        class="bar-wrapper">
        <div
          class="bar"
          [style.width.%]="bar"
        ></div>

        <div class="label">
          {{ showPercentages() ? evaluationDisplayPercentages[i] : evaluationDisplayAbsolute[i] }}
        </div>
      </div>
    </button>
  }
</div>
